/* eslint-disable prettier/prettier */
import { useState, useCallback } from 'react';
import { ActivityType } from '../types/schedule.types';

export function useActivityFilter() {
	const [activeFilters, setActiveFilters] = useState<Set<ActivityType>>(
		new Set()
	);

	const toggleFilter = useCallback((type: ActivityType) => {
		setActiveFilters(prev => {
			const next = new Set(prev);
			if (next.has(type)) {
				next.delete(type);
			} else {
				next.add(type);
			}
			return next;
		});
	}, []);

	const clearFilters = useCallback(() => {
		setActiveFilters(new Set());
	}, []);

	const isFiltered = useCallback(
		(type: ActivityType) => activeFilters.has(type),
		[activeFilters]
	);

	return { activeFilters, toggleFilter, clearFilters, isFiltered };
}
